export default __webpack_public_path__ + "static/media/ubuntu.51ce9b4e.svg";